import { Box, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import { useIsMobile } from "../../../Hooks/useMedia";
import { useAuth } from "../../../Context/Auth/AuthContext";

const Balance = () => {
   const mobile = useIsMobile();
   const { userState } = useAuth();
   return (
      <Box
         sx={{
            position: mobile ? "static" : "absolute",
            top: mobile ? "auto" : "65%", // Vertically centered
            left: "50%", // Horizontally centered
            transform: mobile ? "none" : "translate(-50%, -50%)", // Adjust for exact centering
            display: "flex",
            alignItems: "center", // Aligns items vertically within the Box
            justifyContent: "center", // Center items horizontally
            gap: { xs: 3, sm: 8 }, // Add space between the two Typography components
            width: "auto",
            my: 1,
         }}
      >
         <Typography
            sx={{
               p: 2,
               background: "linear-gradient(135deg, #f5f7fa, #cbcfd5fa)", // Ambient gradient background
               borderRadius: "16px",
               fontSize: { xs: 15, sm: 20 },
               textAlign: "center",
               boxShadow: mobile ? "none" : "-9px 13px 7px 8px rgba(0, 0, 0, 0.1)", // Subtle box shadow before hover
               border: "1px solid #e0e0e0", // Light border for definition
               whiteSpace: "nowrap",
               width: { xs: "fit-content", sm: "fit-content" }, // Fixed width for consistency
            }}
         >
            <span style={{ fontWeight: "bold" }}>$ {userState.data.totalBalance}</span>
            <Divider orientation="horizontal" sx={{ height: 2, background: "#383b4000" }} />
            Wallet Balance
         </Typography>

         {/* Second Typography: Total Reward */}
         <Typography
            sx={{
               p: 2,
               background: "linear-gradient(135deg, #f5f7fa, #cbcfd5fa)", // Ambient gradient background
               borderRadius: "16px",
               fontSize: { xs: 15, sm: 20 },
               textAlign: "center",
               boxShadow: mobile ? "none" : "-9px 13px 7px 8px rgba(0, 0, 0, 0.1)", // Subtle box shadow before hover
               border: "1px solid #e0e0e0", // Light border for definition
               whiteSpace: "nowrap",

               width: { sm: "fit-content" }, // Fixed width for consistency
            }}
         >
            <span style={{ fontWeight: "bold" }}>$ {userState.data.commission}</span>
            <Divider orientation="horizontal" sx={{ height: 2, background: "#383b4000" }} />
            Total Reward
         </Typography>
      </Box>
   );
};

export default Balance;
